/**
 *
 * DevicePreview
 *
 */

import React from "react";
import { toRgba } from "utils/helpers";
import blurredPlaceholder from "./placeholder-blurred.png";
import placeholder from "./placeholder.png";
import classic from "./classic.gif";
import boomerang from "./boomerang.gif";
import ipad from "./ipad.svg";
import browser from "./browser.png";
import still from "./still.png";
import storyVideo from "./story-video.gif";
import standard from "./standard.png";
import blackAndWhite from "./b&w.gif";
import glitch from "./glitch.gif";
import {
  PreviewScreen,
  BackgroundImg,
  LogoImg,
  LogoWrapper,
  Title,
  ButtonWrapper,
  PlaceholderWrapper,
  PlaceholderText,
} from "./styledComponents";

import Device, { Device2 } from "components/Device";
import StartButton from "components/Icon/StartButton";
import Logo from "../Logo";
import { Browser } from "../Device";

const PreviewPlaceholder = ({ isProDevice }) =>
  !isProDevice ? (
    <PlaceholderWrapper>
      <PlaceholderText>LOGO</PlaceholderText>
    </PlaceholderWrapper>
  ) : (
    <Logo scale={4} fill="white" />
  );

const GalleriesPreview = () => (
  <div className="grid grid-cols-8 gap-[1px]">
    {[...Array(16).keys()].map((idx) => (
      <img key={idx} src={placeholder} className="w-full h-auto" alt="" />
    ))}
  </div>
);

const DevicePreview = ({
  backgroundColor = "#555555",
  overlayImage,
  logoImage,
  type,
}) => {
  const bgRGBA = !!backgroundColor && toRgba(backgroundColor);
  const isProDevice = type === "pro";
  const background = !!overlayImage
    ? [`url(${blurredPlaceholder})`, "center"]
    : !!bgRGBA
    ? isProDevice
      ? [
          `linear-gradient(${bgRGBA} 0%, ${bgRGBA} 100%)`,
          "center",
          `url(${blurredPlaceholder})`,
          "center",
        ]
      : [
          `linear-gradient(${bgRGBA} 0%, ${bgRGBA} 100%)`,
          `url(${blurredPlaceholder})`,
          "center",
        ]
    : isProDevice
    ? [
        "linear-gradient(rgba(42, 42, 42, .88) 0%, rgba(42,42,42,.88) 100%)",
        `url(${blurredPlaceholder})`,
        "center",
      ]
    : [
        "linear-gradient(135deg, rgba(214,0,0,.88) 0%, rgba(89,0,195,.88) 100%)",
        `url(${blurredPlaceholder})`,
        "center",
      ];
  const DeviceContainer = isProDevice ? Device2 : Device;

  return (
    <DeviceContainer>
      <PreviewScreen style={{ height: "100%", background }}>
        {overlayImage && (
          <BackgroundImg
            className={isProDevice ? "pro" : ""}
            src={overlayImage}
            alt="logo"
          />
        )}
        <LogoWrapper>
          {logoImage ? (
            <LogoImg src={logoImage} alt="logo" />
          ) : (
            <PreviewPlaceholder isProDevice={isProDevice} />
          )}
        </LogoWrapper>
        {!isProDevice && <Title>PHOTO BOOTH EXPERIENCE</Title>}
        <ButtonWrapper className={isProDevice ? "pro" : ""}>
          <StartButton />
        </ButtonWrapper>
      </PreviewScreen>
    </DeviceContainer>
  );
};

const GalleryPreview = ({
  backgroundColor,
  logoImage,
  headline,
  subHeadline,
  buttonText,
}) => {
  const bgRGBA = !!backgroundColor && toRgba(backgroundColor, 1);

  return (
    <Browser>
      <div
        className="!py-[10px] !px-0 overflow-hidden !bg-center"
        style={{ height: "94%", backgroundColor: bgRGBA }}
      >
        {/* Header section - centered like actual gallery */}
        <div className="flex flex-col items-center px-2 pt-3 pb-2 gap-1">
          {/* Logo */}
          <div className={`${headline || subHeadline ? "w-[28px] h-[14px]" : "w-[80px] h-[40px]"} flex items-center justify-center`}>
            {logoImage ? (
              <img
                src={logoImage}
                className="w-full h-full object-contain"
                alt="logo"
              />
            ) : (
              <Logo scale={headline || subHeadline ? 0.8 : 2} fill="white" />
            )}
          </div>
          {/* Headline - centered, bold */}
          {headline && (
            <div className="w-full text-center font-bold text-[7px] leading-[8px] text-white">
              {headline}
            </div>
          )}
          {/* Sub-headline - centered, lighter weight */}
          {subHeadline && (
            <div className="w-full text-center font-light text-[5px] leading-[6px] text-white/80">
              {subHeadline}
            </div>
          )}
          {/* CTA Button - white background with arrow */}
          {buttonText && (
            <div
              className="mt-[3px] px-[5px] py-[1.5px] bg-white rounded-[1px] flex items-center gap-[2px]"
            >
              <span
                className="text-[3.5px] font-medium leading-none"
                style={{ color: bgRGBA || '#000' }}
              >
                {buttonText}
              </span>
              <svg width="3" height="3" viewBox="0 0 16 16" fill="none">
                <path
                  d="M3.33334 8H12.6667M12.6667 8L8.00001 3.33334M12.6667 8L8.00001 12.6667"
                  stroke={bgRGBA || '#000'}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          )}
        </div>
        {/* Photo grid */}
        <GalleriesPreview />
        <GalleriesPreview />
      </div>
    </Browser>
  );
};

export default DevicePreview;
export {
  blurredPlaceholder,
  placeholder,
  classic,
  boomerang,
  ipad,
  browser,
  GalleryPreview,
  still,
  storyVideo,
  standard,
  blackAndWhite,
  glitch,
};
